
import { RESET_UPLOAD_PURCHASE_ORDER ,UPLOAD_PURCHASE_ORDER_ERROR,UPLOAD_PURCHASE_ORDER_SUCCESS,UPLOAD_PURCHASE_ORDER_REQUEST} from "../actions/action-type";


const initalState = {
    uploadPurchaseOrderResponse: [],
    isuploadPurchaseOrderError: false,
    isuploadPurchaseOrderSuccess: false,
    isuploadPurchaseOrderLoading: false,
    errorDetails:{}
};

const uploadManualPoReducer = (state = initalState, { type, uploadPurchaseOrderResponse,errorDetails }) => {
    switch (type) {
        case UPLOAD_PURCHASE_ORDER_REQUEST:
            return {
                ...state,
                isuploadPurchaseOrderLoading: true,
                isuploadPurchaseOrderError: false,
                isuploadPurchaseOrderSuccess: false
            };
        case UPLOAD_PURCHASE_ORDER_SUCCESS:
            return {
                ...state,
                uploadPurchaseOrderResponse: uploadPurchaseOrderResponse,
                isuploadPurchaseOrderLoading: false,
                isuploadPurchaseOrderError: false,
                isuploadPurchaseOrderSuccess: true,
                errorDetails:{}
            };
        case UPLOAD_PURCHASE_ORDER_ERROR:
            return {
                ...state,
                isuploadPurchaseOrderLoading: false,
                isuploadPurchaseOrderError: true,
                isuploadPurchaseOrderSuccess: false,
                errorDetails:errorDetails
            };
            case RESET_UPLOAD_PURCHASE_ORDER:            
            return initalState
            
                               
        default:
            return state;
    }
};

export default uploadManualPoReducer;